// Атрибуция рекламных кликов Я.Директа (yclid) для офлайн-конверсий.
// Веб:           реклама ведёт на сайт с ?yclid=..., ловим из URL → в заказ.
// Telegram/Max:  метку ловит САМ БОТ из старт-параметра при «Открыть/Старт»
//   (t.me/<bot>?start=yclid_... и max.ru/<bot>?start=yclid_...) → ClickAttribution.

import { getCookieConsent, CONSENT_NECESSARY } from './cookieConsent';
import { getWebClientId } from './analytics';

const KEY = 'stems_yclid';
const MAX_AGE_MS = 21 * 24 * 60 * 60 * 1000; // окно атрибуции Метрики — 21 день

// Юзернеймы ботов — per-client из env (build-time), те же что у ботов
// (BOT_USERNAME / MAX_BOT_USERNAME), проброшены через build-арг.
// Фолбэков нет: раньше тут стояли боты Стемса, и витрина клиента, собранная
// без аргументов, молча вела покупателей в чужие боты. Пустое значение
// прод-сборка не пропустит (проверка в Dockerfile.prod).
const TG_BOT = process.env.REACT_APP_BOT_USERNAME || '';
const MAX_BOT = process.env.REACT_APP_MAX_BOT_USERNAME || '';

// Поймать yclid из URL и сохранить (веб-путь). Вызывать при инициализации приложения.
// При отказе от аналитических cookies (веб, CookieBanner) метку не пишем.
export function captureYclid() {
  try {
    if (getCookieConsent() === CONSENT_NECESSARY) return;
    const yclid = new URLSearchParams(window.location.search).get('yclid');
    if (yclid) {
      localStorage.setItem(KEY, JSON.stringify({ value: yclid.slice(0, 200), ts: Date.now() }));
    }
  } catch (e) { /* no-op */ }
}

// Удалить сохранённую метку — вызывается при отказе от аналитических cookies.
export function clearStoredYclid() {
  try { localStorage.removeItem(KEY); localStorage.removeItem(TOUCH_KEY); } catch (e) { /* no-op */ }
}

// --- Откуда пришёл посетитель (модуль «Источники заказов», 13.10.2026) ---
// При входе на сайт отправляем сырые сигналы (метки в ссылке, откуда перешли) — канал
// распознаёт сервер. Ответ — токен касания: он уходит в заказ и в ссылки на ботов
// (?start=w_<токен>), чтобы заказ в Telegram/Max знал, что человек пришёл, например,
// из Инстаграма. Без сигнала (прямой заход, мини-апп) запрос не шлём.
const TOUCH_KEY = 'stems_touch';
const TOUCH_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;   // окно атрибуции — 30 дней
const API_URL = process.env.REACT_APP_API_URL || '/api';

function externalReferrer() {
  try {
    if (!document.referrer) return '';
    const r = new URL(document.referrer);
    return r.host && r.host !== window.location.host ? document.referrer.slice(0, 500) : '';
  } catch (e) {
    return '';
  }
}

export function captureTouch() {
  try {
    if (getCookieConsent() === CONSENT_NECESSARY) return;
    const q = new URLSearchParams(window.location.search);
    const sig = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'yclid', 'fbclid'].forEach((k) => {
      const v = q.get(k);
      if (v) sig[k] = v.slice(0, 200);
    });
    const referrer = externalReferrer();
    const ua = (navigator.userAgent || '').toLowerCase();
    const inApp = /instagram|fban|fbav|vkclient|vkandroidapp|vkiphoneapp/.test(ua);
    if (!Object.keys(sig).length && !referrer && !inApp) return;
    fetch(`${API_URL}/attribution/touch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...sig, referrer, landing: window.location.pathname.slice(0, 200), web_client_id: getWebClientId() }),
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!d || !d.token) return;
        let prev = null;
        try { prev = JSON.parse(localStorage.getItem(TOUCH_KEY) || 'null'); } catch (e) { prev = null; }
        const fresh = prev && prev.ts && Date.now() - prev.ts < TOUCH_MAX_AGE_MS;
        // Явный источник (наша ссылка, реклама) не затираем распознанным (поиск, соцсети)
        if (!fresh || (d.tier || 2) <= (prev.tier || 2)) {
          localStorage.setItem(TOUCH_KEY, JSON.stringify({ token: d.token, tier: d.tier || 2, ts: Date.now() }));
        }
      })
      .catch(() => {});
  } catch (e) { /* no-op */ }
}

// Токен касания, если не старше 30 дней. Иначе undefined.
export function getTouchToken() {
  try {
    const t = JSON.parse(localStorage.getItem(TOUCH_KEY) || 'null');
    if (!t || !t.token || !t.ts || Date.now() - t.ts > TOUCH_MAX_AGE_MS) return undefined;
    return t.token;
  } catch (e) {
    return undefined;
  }
}

export { getWebClientId };

// Что положить в ?start= ботам: касание сайта (в нём и источник, и метка Директа) или yclid
function startPayload() {
  const t = getTouchToken();
  if (t) return `w_${t}`;
  const y = getStoredYclid();
  return y ? `yclid_${y}` : '';
}

// Достать сохранённый yclid, если он не старше 21 дня. Иначе undefined.
export function getStoredYclid() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return undefined;
    const { value, ts } = JSON.parse(raw);
    if (!value || !ts || Date.now() - ts > MAX_AGE_MS) return undefined;
    return value;
  } catch (e) {
    return undefined;
  }
}

// Ссылка на Telegram-бота (per-client) с рекламной меткой через старт-параметр:
//   t.me/<bot>?start=yclid_<val> → бот ловит её в cmd_start (гарант. подписка).
export function tgBotUrl() {
  if (!TG_BOT) return null; // не задан (dev без env) — href={null} не рендерит ссылку
  const base = `https://t.me/${TG_BOT}`;
  const p = startPayload();
  return p ? `${base}?start=${encodeURIComponent(p)}` : base;
}

// Ссылка на Max-бота (per-client) с рекламной меткой через старт-параметр:
//   max.ru/<bot>?start=yclid_<val> → бот ловит payload в bot_started.
//   Формат ?start= официальный (dev.max.ru/help/deeplinks), payload ≤128 симв.
export function maxBotUrl() {
  if (!MAX_BOT) return null; // не задан (dev без env) — href={null} не рендерит ссылку
  const base = `https://max.ru/${MAX_BOT}`;
  const p = startPayload();
  return p ? `${base}?start=${encodeURIComponent(p)}` : base;
}

// Юзернеймы ботов для подписей/контактных ссылок вне формы входа (без yclid).
export const TG_BOT_USERNAME = TG_BOT;
export const MAX_BOT_USERNAME = MAX_BOT;
